var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMailFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "#7c88b1",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.003 12.955a3.13 3.13 0 00-.528 1.74 3.119 3.119 0 002.37 3.039v2.761a.75.75 0 001.5 0v-2.759a3.129 3.129 0 000-6.082V3.495a.75.75 0 00-1.5 0v8.164a3.126 3.126 0 00-1.842 1.296zm2.49.113a1.624 1.624 0 00-1.05.475 1.63 1.63 0 001.152 2.782 1.62 1.62 0 001.63-1.63 1.63 1.63 0 00-1.529-1.627.758.758 0 01-.202 0zm-9.1-5.562a3.13 3.13 0 001.852 4.778v8.211a.75.75 0 001.5 0v-8.211a3.128 3.128 0 002.32-3.65 3.13 3.13 0 00-2.32-2.428v-2.71a.75.75 0 00-1.5 0v2.71a3.124 3.124 0 00-1.853 1.3zm3.703.67a1.63 1.63 0 11-2.213 2.394 1.63 1.63 0 012.213-2.394zm-10.304 4.78a3.13 3.13 0 001.853 4.778v2.761a.75.75 0 001.5 0v-2.761a3.128 3.128 0 002.32-3.65 3.13 3.13 0 00-2.32-2.428v-8.16a.75.75 0 10-1.5 0v8.16a3.132 3.132 0 00-1.853 1.3zm3.704.67a1.63 1.63 0 11-2.212 2.393 1.63 1.63 0 012.212-2.393z"
  })));
}

export default SvgMailFilter;